export const MVP_STATES = [
  { code: 'WA', name: 'Washington' },
  { code: 'OR', name: 'Oregon' },
  { code: 'CO', name: 'Colorado' },
] as const

export type MvpStateCode = (typeof MVP_STATES)[number]['code']

export const MVP_STATES_NOTE =
  "We're currently onboarding providers in Washington, Oregon, and Colorado. Additional states are coming soon."
